var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_325",
    "data-name": "Group 325",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 42,
    height: 42,
    rx: 12,
    fill: "#e6f3fe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-pin-3--navigation-map-maps-pin-gps-location",
    transform: "translate(13 13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.133,6.316c0,3.878-5.816,8.4-5.816,8.4S2.5,10.194,2.5,6.316A5.874,5.874,0,0,1,8.316.5,5.874,5.874,0,0,1,14.133,6.316Z",
    transform: "translate(0.085 -0.5)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.439,7.378A1.939,1.939,0,1,0,5.5,5.439,1.939,1.939,0,0,0,7.439,7.378Z",
    transform: "translate(0.963 0.378)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.171,10h1.193L17.3,14.524H.5L2.439,10H3.631",
    transform: "translate(-0.5 2.279)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressPinIcon);
export default __webpack_public_path__ + "static/media/address-pin-icon.1d327df530abd69afa84ab8db1e778fb.svg";
export { ForwardRef as ReactComponent };